import variables from '../../styles/variables.module.scss';
import casebg from '../../assets/cases/easyeducation-casebg@2x-min.jpg';

export default {
  path: '/cases/easy-education',
  color: variables.easyEducation,
  casebg,
  description: 'Education in the digital era',
  isWeb: true,
  isAndroid: false,
  title: 'Easy Education',
  headline: 'Web application',
};
